import { Modal, Button, Card } from "react-bootstrap";

/**
 * Aviso anti-ban quando o canal foi desconectado há pouco tempo.
 * Replica o modal "Aviso!" do OrbitSender — usuário pode ignorar e prosseguir.
 */
export default function DisconnectWarningModal({
  show,
  minutesSinceDisconnect,
  onCancel,
  onContinue,
}) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Body className="text-center p-4" style={{ borderColor: "#ffc107" }}>
        <div style={{ fontSize: 48 }}>⚠️</div>
        <h4 className="text-warning">Aviso!</h4>
        <p className="text-muted mb-2">
          Canal desconectado recentemente! Caso tenha sido uma desconexão
          acidental, desconsidere esse aviso, caso a desconexão tenha sido
          automática isso é um possível sinal de identificação da Meta.
        </p>
        <p className="font-weight-bold">
          Recomendamos o uso de outro número ou aguardar cerca de 40 minutos.
        </p>

        <Card
          bg="warning"
          text="dark"
          className="my-3 p-2 text-center"
          style={{ background: "rgba(255, 193, 7, 0.15)", border: 0 }}
        >
          <strong>
            Última desconexão:{" "}
            {minutesSinceDisconnect != null
              ? `${minutesSinceDisconnect} minuto(s) atrás`
              : "agora"}
          </strong>
        </Card>

        <div className="d-flex justify-content-center" style={{ gap: 8 }}>
          <Button variant="secondary" onClick={onCancel}>
            Cancelar
          </Button>
          <Button variant="warning" onClick={onContinue}>
            Continuar
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
